import React, { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Checkbox from '@narvar/nth-checkbox';
import TextInput from '@narvar/nth-text-input';
import { Language, rawString } from '../Language';
import s from './style.module.css';

export const SignatureAttestation = ({
  titleText,
  descriptionText,
  signatureHeader,
  checkboxText,
  placeholder,
  onChange,
  signatureBox = true,
  checkbox = true,
  backdrop,
  signatureText,
  checked: checkedProp,
}) => {
  const [name, setName] = useState(signatureText);
  const [checked, setChecked] = useState(checkedProp || false);
  const handleNameChange = (e) => {
    setName(e.target.value);
    onChange({
      name: e.target.value,
      checked,
    });
  };

  const handleCheckboxChange = () => {
    const updated = !checked;
    setChecked(updated);

    onChange({
      name,
      checked: updated,
    });
  };
  return (
    <div className={cx(backdrop ? s.wrapper : null, 'signature-attestation-wrapper')}>
      <Language {...titleText} className={cx(s.title, 'signature-attestation-title')} />
      <Language {...descriptionText} className="signature-attestation-description" />
      <Language
        {...signatureHeader}
        className={cx(s.signatureHeader, 'signature-attestation-signature-header')}
      />
      {signatureBox && (
        <TextInput
          value={signatureText || name}
          placeholder={rawString(placeholder)}
          onChange={handleNameChange}
          className="signature-attestation-textbox"
        />
      )}
      {checkbox && (
        <div className={cx(s.checkboxWrapper, 'checkboxWrapper')}>
          <Checkbox
            id="signature-attestation-checkbox"
            checked={checkedProp || checked}
            onChange={handleCheckboxChange}
          >
            <Language {...checkboxText} />
          </Checkbox>
        </div>
      )}
    </div>
  );
};

SignatureAttestation.defaultProps = {
  onChange: () => {},
  titleText: undefined,
  descriptionText: undefined,
  signatureHeader: undefined,
  checkboxText: undefined,
  placeholder: undefined,
  signatureBox: true,
  checkbox: true,
  backdrop: false,
  signatureText: undefined,
  checked: false,
};

SignatureAttestation.propTypes = {
  titleText: PropTypes.shape({ langKey: PropTypes.string, content: PropTypes.string }),
  descriptionText: PropTypes.shape({ langKey: PropTypes.string, content: PropTypes.string }),
  signatureHeader: PropTypes.shape({ langKey: PropTypes.string, content: PropTypes.string }),
  checkboxText: PropTypes.shape({ langKey: PropTypes.string, content: PropTypes.string }),
  placeholder: PropTypes.shape({ langKey: PropTypes.string, content: PropTypes.string }),
  onChange: PropTypes.func,

  signatureBox: PropTypes.bool,
  checkbox: PropTypes.bool,
  backdrop: PropTypes.bool,
  signatureText: PropTypes.string,
  checked: PropTypes.bool,
};
